export default __webpack_public_path__ + "static/media/because-the-internet.926c0b17.jpg";